import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { GenericSelect } from "@shared/components/Select";
import { Mail } from "lucide-react";
import { useState } from "react";


type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  email: string;
  templates: any[];
  onSend: (templateId?: string) => void;
};

export const SendBillDialog = ({
  open,
  onOpenChange,
  email,
  templates,
  onSend,
}: Props) => {
  const [selectedTemplate, setSelectedTemplate] = useState<string | undefined>(
    undefined
  );

  const handleSend = () => {
    onSend(selectedTemplate);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[460px]">
        <DialogHeader>
          <DialogTitle>Send Bill via Email</DialogTitle>
          <DialogDescription>
            A PDF copy of the bill will be sent to the consumer&apos;s email
            address.
          </DialogDescription>
        </DialogHeader>

        {/* Email Info */}
        <div className="flex items-center gap-3 rounded-md bg-blue-50 px-4 py-3 text-sm text-blue-600">
          <Mail className="h-5 w-5" />
          <span>
            Sending to: <span className="font-medium">{email}</span>
          </span>
        </div>

        {/* Template Selector */}
        <div className="space-y-2">
          <label className="text-sm font-medium">Communication Template</label>
          <GenericSelect
            value={selectedTemplate}
            onChange={setSelectedTemplate}
            options={templates}
            placeholder="Select a template"
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSend}>Send Mail</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
